import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_item, {
      clickable: "",
      dense: "",
      onClick: _withModifiers(_ctx.toggleAll, ["stop"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item_section, { side: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_checkbox, {
              "model-value": _ctx.determinate,
              "indeterminate-value": null,
              "toggle-indeterminate": false,
              dense: "",
              "onUpdate:modelValue": _ctx.toggleAll
            }, null, 8, ["model-value", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_q_item_section, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_label, { class: "text-weight-bold" }, {
              default: _withCtx(() => [
                _createTextVNode("All Post Statuses")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onClick"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
      return (_openBlock(), _createBlock(_component_q_item, {
        key: option.value,
        clickable: "",
        dense: "",
        onClick: _withModifiers(($event: any) => (_ctx.toggle(option.value)), ["stop"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { side: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_checkbox, {
                "model-value": _ctx.isSelected(option.value),
                dense: "",
                "onUpdate:modelValue": ($event: any) => (_ctx.toggle(option.value))
              }, null, 8, ["model-value", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_q_item_section, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_label, { class: "row items-center no-wrap" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(option.label) + " ", 1),
                  _createVNode(_component_q_space),
                  (option.tooltip)
                    ? (_openBlock(), _createBlock(_component_q_icon, {
                        key: 0,
                        name: "fas fa-info-circle",
                        size: "xs",
                        color: "grey-6",
                        class: "q-ml-xs"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(option.tooltip), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1032, ["onClick"]))
    }), 128))
  ]))
}